module.exports = __webpack_public_path__ + "static/img/Chris-Faagutu.cfd8703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chris-Faagutu.jpg
// module id = TmXD
// module chunks = 0